import { render, staticRenderFns } from "./CreateClientDoc.vue?vue&type=template&id=7ecd4b90"
import script from "./CreateClientDoc.vue?vue&type=script&lang=js"
export * from "./CreateClientDoc.vue?vue&type=script&lang=js"
import style0 from "./CreateClientDoc.vue?vue&type=style&index=0&id=7ecd4b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports